<template>
  <b-card>
    <b-modal v-model="showConfirm" title="Confirm Changes" centered hide-footer>
      <p class="text-black">
        This applies immediately to every player. Players will unlock Turnover
        Rebate bonus cash for every
        <b>{{ formatAmount(threshold) }} USDT</b> in turnover. Continue?
      </p>
      <div class="d-flex justify-content-end">
        <b-button
          variant="outline-secondary"
          class="mr-1"
          @click="showConfirm = false"
          >Cancel</b-button
        >
        <b-button variant="success" :disabled="saving" @click="handleSave">
          <b-spinner v-if="saving" small class="mr-50" />
          Confirm &amp; Save
        </b-button>
      </div>
    </b-modal>

    <div v-if="loading" class="text-center py-3">
      <b-spinner variant="primary" />
    </div>
    <b-form v-else @submit.prevent>
      <p class="font-weight-bolder border-bottom">Turnover Rebate</p>
      <b-row>
        <b-col cols="12">
          <b-form-group>
            <label class="font-weight-bold" for="stake-bonus-threshold"
              >Turnover per claim</label
            >
            <b-input-group append="USDT">
              <b-form-input
                id="stake-bonus-threshold"
                v-model.number="threshold"
                type="number"
                min="0"
                :state="thresholdValid ? null : false"
              />
            </b-input-group>
            <small v-if="!thresholdValid" class="text-danger"
              >Must be greater than 0</small
            >
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <p class="text-muted mb-1">
            <feather-icon icon="InfoIcon" class="mr-25" />
            Players unlock bonus cash for every
            <b>{{ formatAmount(threshold) }} USDT</b> in turnover.
          </p>
        </b-col>
        <b-col cols="12">
          <div class="d-flex justify-content-end align-items-center">
            <b-button
              variant="success"
              :disabled="saving || !thresholdValid || threshold === savedThreshold"
              @click="showConfirm = true"
            >
              <feather-icon icon="SaveIcon" />
              Save Changes</b-button
            >
          </div>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BCard,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BButton,
  BModal,
  BSpinner,
} from "bootstrap-vue";
import { mapState, mapActions } from "vuex";
import useToastHandler from "@/services/toastHandler";

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BButton,
    BModal,
    BSpinner,
  },
  data() {
    return {
      showConfirm: false,
      threshold: 10000,
      savedThreshold: null,
    };
  },
  computed: {
    ...mapState("settings/stake-bonus-threshold", ["loading", "saving"]),
    thresholdValid() {
      const v = this.threshold;
      return v !== "" && v !== null && v > 0;
    },
  },
  created() {
    this.fetchSettings();
  },
  methods: {
    ...mapActions("settings/stake-bonus-threshold", [
      "getStakeBonusThreshold",
      "updateStakeBonusThreshold",
    ]),
    formatAmount(value) {
      return Number(value || 0).toLocaleString("en-US", {
        maximumFractionDigits: 2,
      });
    },
    async fetchSettings() {
      const data = await this.getStakeBonusThreshold();
      if (data?.value !== undefined && data?.value !== null) {
        this.threshold = Number(data.value);
        this.savedThreshold = this.threshold;
      }
    },
    async handleSave() {
      if (!this.thresholdValid) return;
      const value = Number(this.threshold);
      const result = await this.updateStakeBonusThreshold(value);
      if (result) {
        this.savedThreshold = value;
        this.showConfirm = false;
        this.showToastSuccess(
          "Settings saved",
          "Turnover rebate updated successfully."
        );
      }
    },
  },
  setup() {
    const { showToastSuccess } = useToastHandler();
    return { showToastSuccess };
  },
};
</script>
